module.exports = __webpack_public_path__ + "static/banner-update-data-pe-MB-cc947fc78012e044b8120db6b60c242d.png";